import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 3rem 1.5rem;
  background-color: #f8f9fa;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 700px;
  width: 100%;
  padding: 2.5rem;
`;

const Title = styled.h1`
  color: #0d9488;
  margin-bottom: 0.5rem;
`;

const UpdatedAt = styled.p`
  color: #999;
  font-size: 0.85rem;
  margin-bottom: 2rem;
`;

const Body = styled.div`
  color: #444;
  line-height: 1.7;

  h2 {
    color: #333;
    font-size: 1.15rem;
    margin: 1.75rem 0 0.5rem;
  }

  p, li {
    margin-bottom: 0.75rem;
  }

  ul {
    padding-left: 1.25rem;
  }
`;

const BackLink = styled(Link)`
  display: inline-block;
  margin-top: 2rem;
  color: #0d9488;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const LegalPage = ({ title, updatedAt, children }) => (
  <Container>
    <Card>
      <Title>{title}</Title>
      <UpdatedAt>Last updated {updatedAt}</UpdatedAt>
      <Body>{children}</Body>
      <BackLink to="/">&larr; Back to ConvoCoach</BackLink>
    </Card>
  </Container>
);

export default LegalPage;
